export const arrayToSelectOptions = (arr = [], sort = false) => {
  let options = arr.map((value) => ({ val: value, text: value }));

  if (sort) {
    options.sort((a, b) => a.text.localeCompare(b.text));
  }

  options.unshift({ val: "", text: "Select" });

  return options;
};



// WEBPACK FOOTER //
// ./src/utils/arrayToSelectOptions.js